// Copyright 2018 Sorama B.V.

// icons
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faInternetExplorer } from "@fortawesome/free-brands-svg-icons/faInternetExplorer";
import { faUsb } from "@fortawesome/free-brands-svg-icons/faUsb";
import {
    faChevronCircleLeft,
    faChevronCircleRight,
    faBookmark as farFaBookmark,
    faStar as farFaStar,
    faHeadSideBrain as farHeadSideBrain,
} from "@fortawesome/pro-regular-svg-icons";
import {
    faAlignCenter,
    faAlignLeft,
    faAlignRight,
    faAlignSlash,
    faAnalytics,
    faArrowAltToBottom,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowsAlt,
    faArrowsAltH,
    faArrowsAltV,
    faArrowToBottom,
    faArrowUp,
    faAsterisk,
    faBan,
    faBars,
    faBell,
    faBolt,
    faBook,
    faBug,
    faCalendar,
    faCalendarAlt,
    faCamera,
    faCaretDown,
    faCaretUp,
    faChartBar,
    faCheck,
    faCheckCircle,
    faChessBoard,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faClipboard,
    faClock,
    faClone,
    faCloud,
    faCloudUpload,
    faCog,
    faCogs,
    faComment,
    faCommentAltSmile,
    faCompress,
    faCrosshairs,
    faCut,
    faDatabase,
    faDotCircle,
    faDownload,
    faEdit,
    faEllipsisV,
    faEnvelope,
    faEraser,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExternalLink,
    faEye,
    faEyeSlash,
    faFile,
    faFileChartLine,
    faFileCsv,
    faFill,
    faFilter,
    faFlagCheckered,
    faFlask,
    faFolderOpen,
    faFolders,
    faGasPump,
    faGlobe,
    faGripVertical,
    faHandPaper,
    faHandshake,
    faHdd,
    faHome,
    faHourglass,
    faHourglassHalf,
    faImage,
    faImages,
    faInfo,
    faInfoCircle,
    faLayerGroup,
    faLayerPlus,
    faLevelUpAlt,
    faLightbulb,
    faLink,
    faList,
    faLock,
    faLockOpen,
    faMagic,
    faMapPin,
    faMapSigns,
    faMeh,
    faMicrophone,
    faMinus,
    faMinusCircle,
    faOutdent,
    faPalette,
    faPause,
    faPencil,
    faPhone,
    faPhotoVideo,
    faPlay,
    faPlus,
    faPlusCircle,
    faPresentation,
    faQuestion,
    faQuestionCircle,
    faRepeat,
    faRss,
    faRulerCombined,
    faSearch,
    faSearchMinus,
    faSearchPlus,
    faBookmark as fasFaBookmark,
    faStar as fasFaStar,
    faShareSquare,
    faShoppingBasket,
    faSlidersH,
    faSort,
    faSortAlphaDown,
    faSortAlphaUp,
    faSortAmountDown,
    faSortAmountUp,
    faSortDown,
    faSortNumericDown,
    faSortNumericUp,
    faSortUp,
    faSpinner,
    faSplotch,
    faStarExclamation,
    faStarOfDavid,
    faStarOfLife,
    faStop,
    faSync,
    faSyncAlt,
    faThermometer,
    faThermometerHalf,
    faThermometerThreeQuarters,
    faThumbtack,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faUndo,
    faUndoAlt,
    faUnlink,
    faUpload,
    faUser,
    faVideo,
    faVideoSlash,
    faVolumeMute,
    faVolumeUp,
    faWind,
} from "@fortawesome/pro-solid-svg-icons";

export class IconsInstaller {
    public static installIcons(): void {
        library.add(faStarOfDavid);
        library.add(faStarOfLife);
        library.add(faStarExclamation);
        library.add(faBell);
        library.add(faGlobe);
        library.add(faUser);
        library.add(faList);
        library.add(faGripVertical);
        library.add(faExclamationCircle);
        library.add(faTimes);
        library.add(faSync);
        library.add(faPencil);
        library.add(faCheck);
        library.add(faCheckCircle);
        library.add(faChevronUp);
        library.add(faChevronDown);
        library.add(faChevronLeft);
        library.add(faChevronRight);
        library.add(faUndo);
        library.add(faClock);
        library.add(faTrash);
        library.add(faPlus);
        library.add(faSort);
        library.add(faSortUp);
        library.add(faSortDown);
        library.add(faPhone);
        library.add(faEnvelope);
        library.add(faExclamation);
        library.add(faBan);
        library.add(faChartBar);
        library.add(faOutdent);
        library.add(faRss);
        library.add(faArrowLeft);
        library.add(faCog);
        library.add(faCogs);
        library.add(faCloudUpload);
        library.add(faExclamationTriangle);
        library.add(faSpinner);
        library.add(faAsterisk);
        library.add(faUsb);
        library.add(faHdd);
        library.add(faQuestion);
        library.add(faCamera);
        library.add(faMinus);
        library.add(faQuestionCircle);
        library.add(faInternetExplorer);
        library.add(faMeh);
        library.add(faInfoCircle);
        library.add(faInfo);
        library.add(faThumbtack);
        library.add(faUnlink);
        library.add(faLink);
        library.add(faMagic);
        library.add(faCalendar);
        library.add(faHourglass);
        library.add(faMicrophone);
        library.add(faDownload);
        library.add(faRepeat);
        library.add(faVideo);
        library.add(faVideoSlash);
        library.add(faHourglassHalf);
        library.add(faDotCircle);
        library.add(faCloud);
        library.add(faClone);
        library.add(faPlay);
        library.add(faClipboard);
        library.add(faEye);
        library.add(faEyeSlash);
        library.add(faStop);
        library.add(faThermometer);
        library.add(faMapSigns);
        library.add(faFlask);
        library.add(faBug);
        library.add(faEraser);
        library.add(faChessBoard);
        library.add(faThermometerHalf);
        library.add(faThermometerThreeQuarters);
        library.add(faMapPin);
        library.add(faExpand);
        library.add(faCompress);
        library.add(faPause);
        library.add(faBars);
        library.add(faSortAlphaDown);
        library.add(faSortAlphaUp);
        library.add(faSortNumericDown);
        library.add(faSortNumericUp);
        library.add(faTrashAlt);
        library.add(faSortAmountDown);
        library.add(faSortAmountUp);
        library.add(faDatabase);
        library.add(faTimesCircle);
        library.add(faCrosshairs);
        library.add(faArrowAltToBottom);
        library.add(faSyncAlt);
        library.add(faHome);
        library.add(faSearch);
        library.add(faSearchPlus);
        library.add(faSearchMinus);
        library.add(faImages);
        library.add(faUpload);
        library.add(faHandPaper);
        library.add(faHandshake);
        library.add(faLock);
        library.add(faLockOpen);
        library.add(faVolumeUp);
        library.add(faVolumeMute);
        library.add(faUndoAlt);
        library.add(faFolders);
        library.add(faFolderOpen);
        library.add(faAnalytics);
        library.add(faMinusCircle);
        library.add(faPlusCircle);
        library.add(faChevronCircleLeft);
        library.add(faChevronCircleRight);
        library.add(faArrowsAlt);
        library.add(faArrowsAltV);
        library.add(faArrowsAltH);
        library.add(faArrowRight);
        library.add(faAlignSlash);
        library.add(faFileCsv);
        library.add(faFile);
        library.add(faPhotoVideo);
        library.add(faImage);
        library.add(faComment);
        library.add(faCommentAltSmile);
        library.add(faFlagCheckered);
        library.add(faEdit);
        library.add(faCut);
        library.add(faLightbulb);
        library.add(faLevelUpAlt);
        library.add(faBook);
        library.add(faPresentation);
        library.add(faEllipsisV);
        library.add(faCalendarAlt);
        library.add(faLayerPlus);
        library.add(faLayerGroup);
        library.add(faArrowUp);
        library.add(faArrowDown);
        library.add(faAlignLeft);
        library.add(faAlignCenter);
        library.add(faAlignRight);
        library.add(faPalette);
        library.add(faFill);
        library.add(faExternalLink);
        library.add(faRulerCombined);
        library.add(faFileChartLine);
        library.add(fasFaBookmark, farFaBookmark);
        library.add(faSplotch);
        library.add(faFilter);
        library.add(faShareSquare);
        library.add(faCaretDown);
        library.add(faCaretUp);
        library.add(fasFaStar, farFaStar);
        library.add(faShoppingBasket);
        library.add(faBolt);
        library.add(faGasPump);
        library.add(faWind);
        library.add(farHeadSideBrain);
        library.add(faArrowToBottom);
        library.add(faSlidersH);

        // Kicks off the process of finding <i> tags and replacing with <svg>
        dom.watch();
    }
}
